module.exports = __webpack_public_path__ + "static/media/city-location.bf17b0ea.svg";